import * as React from 'react';
import {Button} from 'shared-portal-components-v2';

export interface OwnerCandidateRowProps {
  name: string;
  email: string;
  initials: string;
  onAdd: () => void;
}

export function OwnerCandidateRow(props: OwnerCandidateRowProps): React.JSX.Element {
  const { name, email, initials, onAdd } = props;

  return (
    <div className="flex items-center justify-between gap-2 p-3 rounded-lg border hover:bg-muted/50">
      <div className="flex items-center space-x-3 min-w-0">
        <div className="w-8 h-8 bg-muted rounded-full flex items-center justify-center shrink-0">
          <span className="text-xs font-medium">{initials}</span>
        </div>

        <div className="min-w-0">
          <div className="font-medium truncate">{name}</div>
          <div className="text-sm text-muted-foreground truncate">{email}</div>
        </div>
      </div>

      <Button
        type="button"
        variant="outline"
        onClick={onAdd}
        className="border border-border bg-background hover:bg-surface hover:text-foreground rounded-md px-3 h-8 text-xs whitespace-nowrap shrink-0"
      >
        Add as Owner
      </Button>
    </div>
  );
}

OwnerCandidateRow.displayName = 'OwnerCandidateRow';

export default OwnerCandidateRow;
